
import "../Foundation/stylable/colors.st.css.js";
import "../Tooltip/Tooltip.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_130_0_ModalPreviewLayout";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_130_0_ModalPreviewLayout__root","header":"wds_1_130_0_ModalPreviewLayout__header","title":"wds_1_130_0_ModalPreviewLayout__title","actions":"wds_1_130_0_ModalPreviewLayout__actions","closeButton":"wds_1_130_0_ModalPreviewLayout__closeButton","innerOverlay":"wds_1_130_0_ModalPreviewLayout__innerOverlay","content":"wds_1_130_0_ModalPreviewLayout__content","navigationButton":"wds_1_130_0_ModalPreviewLayout__navigationButton","left-arrow":"wds_1_130_0_ModalPreviewLayout__left-arrow","right-arrow":"wds_1_130_0_ModalPreviewLayout__right-arrow","modalTooltip":"wds_1_130_0_ModalPreviewLayout__modalTooltip"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"headerHeight":"66px","titleWidth":"20%","actionsWidth":"60%"}; 
export var vars = {}; 




